import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const ParallaxDocumentsBlock = ({
  key,
  heading=null,
  content=null,
  button=null,
  document1=null,
  document2=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="parallax-documents-block">
      <div className="parallax-documents-block-inner">
        <div className="content-col-responsive">
          <div className="container">
            <div className="col-12">
              <div className="col-12 col-md-10 col-xl-8 offset-md-1 offset-xl-3 parallax-text-content">
                {heading &&
                  <h2 className={ `content-title white ${content ? "orange-dash" : ""}` }>{ htmlDecode(heading) }</h2>
                }
                {content &&
                  <div className="section-content white" dangerouslySetInnerHTML={{ __html: content }} />
                }
                <div className="btn-row d-flex">
                  {button &&
                    <Link href={ button.link } target={ `${button.openNewTab ? "_blank" : "_self"}` } className="button inverse mr2">{ button.text }</Link>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 offset-md-6 d-none d-md-flex parallax-image-content">
          <div className="col-12 content-inner">
            {document1 &&
              <>
                {document1?.formats?.medium &&
                  <img className="doc1" src={document1.formats.medium.url.includes(cdnUrl) ? document1.formats.medium.url : cdnUrl + document1.formats.medium.url} alt={ document1?.alternativeText } />
                }
                {!document1?.formats?.medium &&
                  <img className="doc1" src={document1.url.includes(cdnUrl) ? document1.url : cdnUrl + document1.url} alt={ document1?.alternativeText } />
                }
              </>
            }
            {document2 &&
              <>
                {document2?.formats?.medium &&
                  <img className="doc2" src={document2.formats.medium.url.includes(cdnUrl) ? document2.formats.medium.url : cdnUrl + document2.formats.medium.url} alt={ document2?.alternativeText } />
                }
                {!document2?.formats?.medium &&
                  <img className="doc2" src={document2.url.includes(cdnUrl) ? document2.url : cdnUrl + document2.url} alt={ document2?.alternativeText } />
                }
              </>
            }
          </div>
        </div>
      </div>
      <div className="col-11 offset-1 col-md-6 offset-md-4 d-flex d-md-none parallax-image-content">
        <div className="col-12 content-inner ">
          {document1 &&
            <>
              {document1?.formats?.medium &&
                <img className="doc1" src={document1.formats.medium.url.includes(cdnUrl) ? document1.formats.medium.url : cdnUrl + document1.formats.medium.url} alt={ document1?.alternativeText } />
              }
              {!document1?.formats?.medium &&
                <img className="doc1" src={document1.url.includes(cdnUrl) ? document1.url : cdnUrl + document1.url} alt={ document1?.alternativeText } />
              }
            </>
          }
          {document2 &&
            <>
              {document2?.formats?.medium &&
                <img className="doc2" src={document2.formats.medium.url.includes(cdnUrl) ? document2.formats.medium.url : cdnUrl + document2.formats.medium.url} alt={ document2?.alternativeText } />
              }
              {!document2?.formats?.medium &&
                <img className="doc2" src={document2.url.includes(cdnUrl) ? document2.url : cdnUrl + document2.url} alt={ document2?.alternativeText } />
              }
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default ParallaxDocumentsBlock
